"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRelativeDate = exports.toUTCFormat = exports.convertToISOString = exports.formatDate = exports.formatLocaleTime = exports.formatLocaleDateTime = exports.formatLocaleDate = void 0;
const date_fns_1 = require("date-fns");
const i18next_1 = __importDefault(require("i18next"));
const elements_core_i18n_1 = require("@hydrogen/elements.core.i18n");
const getLocaleLanguage = () => i18next_1.default.language || elements_core_i18n_1.DEFAULT_LANGUAGE;
const formatLocaleDate = (date, { isLong = false } = {}) => ((0, date_fns_1.format)(date, isLong ? 'PPP' : 'P', { locale: (0, elements_core_i18n_1.getDateLocale)(getLocaleLanguage()) }));
exports.formatLocaleDate = formatLocaleDate;
const formatLocaleDateTime = (date, { isLong = false, hasTimeZone = false } = {}) => {
    const localeLanguage = getLocaleLanguage();
    const dateTimePattern = isLong
        ? `PPpp${hasTimeZone ? 'p' : ''}`
        : `Pp${hasTimeZone ? 'pp' : ''}`;
    return (0, date_fns_1.format)(date, dateTimePattern, { locale: (0, elements_core_i18n_1.getDateLocale)(localeLanguage) });
};
exports.formatLocaleDateTime = formatLocaleDateTime;
const formatLocaleTime = (date) => {
    const localeLanguage = getLocaleLanguage();
    return (0, date_fns_1.format)(date, 'p', { locale: (0, elements_core_i18n_1.getDateLocale)(localeLanguage) });
};
exports.formatLocaleTime = formatLocaleTime;
const formatDate = (date, formatter, language) => ((0, date_fns_1.format)(date, formatter || elements_core_i18n_1.DEFAULT_FORMAT, { locale: (0, elements_core_i18n_1.getDateLocale)(language || getLocaleLanguage()) }));
exports.formatDate = formatDate;
const convertToISOString = (date) => ((0, date_fns_1.set)(new Date(date), { seconds: 0, milliseconds: 0 }).toISOString());
exports.convertToISOString = convertToISOString;
const toUTCFormat = (date) => {
    if (typeof date !== 'string')
        return date;
    if (date.includes('+') || date.includes('Z'))
        return date;
    return `${date}+00:00`;
};
exports.toUTCFormat = toUTCFormat;
const formatRelativeDate = (date, baseDate, language) => ((0, date_fns_1.formatDistance)(date, baseDate, {
    locale: (0, elements_core_i18n_1.getDateLocale)(language || getLocaleLanguage()),
    addSuffix: true,
}));
exports.formatRelativeDate = formatRelativeDate;
//# sourceMappingURL=dates.js.map